import * as braze from '@braze/web-sdk';
import { actionsFactory, props } from '@ngneat/effects';

const contentCardsActions = actionsFactory('content-cards');

export const subscribeToContentCards = contentCardsActions.create(
  'Subscribe To Content Cards'
);

export const setContentCards = contentCardsActions.create(
  'Set Content Cards',
  props<{ contentCards: braze.ContentCards }>()
);

export const handleContentCardClicked = contentCardsActions.create(
  'Handle Content Card Clicked',
  props<{ id: string }>()
);

export const updateContentCard = contentCardsActions.create(
  'Update Content Card',
  props<{ card: braze.Card }>()
);

export const dismissContentCard = contentCardsActions.create(
  'Dismiss Content Card',
  props<{ card: braze.Card }>()
);
